import { render, staticRenderFns } from "./Send.vue?vue&type=template&id=0e9713de&scoped=true"
import script from "./Send.vue?vue&type=script&lang=js"
export * from "./Send.vue?vue&type=script&lang=js"
import style0 from "./Send.vue?vue&type=style&index=0&id=0e9713de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9713de",
  null
  
)

export default component.exports